// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { Card, Col, FormControl, Row, Table } from "react-bootstrap";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import { FiEdit2, FiTrash2, FiEye } from "react-icons/fi";
// import Form from "react-bootstrap/Form";
// import { authHeader } from "../../services/auth-header";
// import { BASE_URL } from "../../services/Api";
// import { debounce } from "lodash";
// import { useFetchProductTableData } from "./useFetchProductTableData";
// import Swal from "sweetalert2";

// const ProductComponents = ({
//     header,
//     tableTitle,
//     apiField,
//     addButton,
//     createRoute,
//     updateRoute,
//     viewRoute,
//     selectedBrand = "1",
//     selectedProductType = "Finished",
//     brands = [],
//     productTypes = [],
//     onBrandChange,
//     onProductTypeChange
// }) => {
//     const { pointindex } = useParams();
//     const navigate = useNavigate();

//     const count = [{ value: 5 }, { value: 10 }, { value: 20 }, { value: 50 }];

//     // Pagination / Sorting / Search states
//     const [searchInput, setSearchInput] = useState("");
//     const [search, setSearch] = useState(encodeURIComponent(" "));
//     const [currentPage, setCurrentPage] = useState(pointindex ? pointindex - 1 : 0);
//     const [limit, setLimit] = useState(5);
//     const [sort, setSort] = useState("desc");
//     const [currentValue, setCurrentValue] = useState("id");

//     // Custom hook to fetch data - now with brand and productType
//     const { data: projectionData, pages, totalEnteries, refetch } = useFetchProductTableData({
//         apiField,
//         limit,
//         sort,
//         currentValue,
//         search,
//         currentPage,
//         brandId: selectedBrand,
//         productType: selectedProductType
//     });

//     // Debounce search input
//     useEffect(() => {
//         const debounced = debounce(() => {
//             setSearch(encodeURIComponent(searchInput.trim() || " "));
//             setCurrentPage(0);
//         }, 300);
//         debounced();
//         return () => debounced.cancel();
//     }, [searchInput]);

//     // Reset to first page when brand or product type changes
//     useEffect(() => {
//         setCurrentPage(0);
//     }, [selectedBrand, selectedProductType]);

//     const limitHandler = (e) => {
//         setLimit(e.target.value);
//         setCurrentPage(0);
//     };

//     const sortHandler = (value) => {
//         setSort(sort === "asc" ? "desc" : "asc");
//         setCurrentValue(value);
//     };

//     const addButtonHandler = () => {
//         navigate(createRoute);
//     };

//     const updateHandler = (id) => {
//         navigate(`${updateRoute}/${id}/${currentPage + 1}`);
//     };

//     const deleteHandler = (id) => {
//         Swal.fire({
//             title: 'Are you sure?',
//             text: "You won't be able to revert this!",
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes, delete it!'
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 fetch(`${BASE_URL}${apiField}/delete/${id}`, {
//                     method: "DELETE",
//                     headers: authHeader()
//                 })
//                     .then(async (response) => {
//                         const responseText = await response.text();
//                         let responseData;

//                         try {
//                             responseData = JSON.parse(responseText);
//                         } catch {
//                             responseData = responseText;
//                         }

//                         if (response.ok) {
//                             await Swal.fire({
//                                 title: 'Deleted!',
//                                 text: typeof responseData === 'string'
//                                     ? responseData
//                                     : (responseData.message || 'Item deleted successfully'),
//                                 icon: 'success'
//                             });

//                             refetch();
//                         } else {
//                             throw new Error(typeof responseData === 'string'
//                                 ? responseData
//                                 : (responseData.message || 'Failed to delete item'));
//                         }
//                     })
//                     .catch(error => {
//                         Swal.fire({
//                             title: 'Error',
//                             text: error.message,
//                             icon: 'error'
//                         });
//                     });
//             }
//         });
//     };

//     const viewHandler = (label, id) => {
//         if (label === "Id" && viewRoute) {
//             navigate(`${viewRoute}/${id}/${currentPage + 1}`);
//         }
//     };

//     const handleRecentPage = (i) => {
//         setCurrentPage(i - 1);
//     };

//     const previousHandler = () => {
//         setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
//     };

//     const nextHandler = () => {
//         setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
//     };

//     const renderPagination = () => {
//         const totalPages = pages;
//         const maxPagesToShow = 5;
//         const siblingsCount = 2;
//         const firstPage = 1;
//         const lastPage = totalPages;
//         let pageNumbers = [];

//         const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
//         const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

//         if (startPage > firstPage + 1) {
//             pageNumbers.push(
//                 <button
//                     key={firstPage}
//                     className="brand-page-btn"
//                     onClick={() => handleRecentPage(firstPage)}
//                 >
//                     {firstPage}
//                 </button>
//             );
//             pageNumbers.push(<span key="dots-start" className="brand-page-dots">...</span>);
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     className={`brand-page-btn ${i === currentPage + 1 ? 'active' : ''}`}
//                     onClick={() => handleRecentPage(i)}
//                 >
//                     {i}
//                 </button>
//             );
//         }

//         if (endPage < lastPage - 1) {
//             pageNumbers.push(<span key="dots-end" className="brand-page-dots">...</span>);
//             pageNumbers.push(
//                 <button
//                     key={lastPage}
//                     className="brand-page-btn"
//                     onClick={() => handleRecentPage(lastPage)}
//                 >
//                     {lastPage}
//                 </button>
//             );
//         }

//         return pageNumbers;
//     };

//     return (
//         <Card className="brand-card">
//             <Card.Header className="brand-header">
//                 <h6>{tableTitle}</h6>

//                 {addButton && (
//                     <button
//                         className="button-70"
//                         onClick={addButtonHandler}
//                     >
//                         {addButton}
//                     </button>
//                 )}
//             </Card.Header>

//             <Card.Body className="brand-body">
//                 <div
//                     style={{
//                         display: "flex",
//                         flexWrap: "wrap",
//                         alignItems: "center",
//                         gap: "1rem",
//                         marginBottom: "1rem",
//                     }}
//                 >
//                     {/* Show Entries */}
//                     <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
//                         <span>Show entries:</span>
//                         <Form.Select onChange={limitHandler} value={limit}>
//                             {count.map((item) => (
//                                 <option key={item.value} value={item.value}>
//                                     {item.value}
//                                 </option>
//                             ))}
//                         </Form.Select>
//                     </div>

//                     {/* Brand Filter */}
//                     {brands.length > 0 && (
//                         <div
//                             style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "0.5rem",
//                                 marginLeft: "auto",
//                             }}
//                         >
//                             <span>Brand:</span>
//                             <Form.Select
//                                 style={{
//                                     minWidth: "200px",
//                                     maxWidth: "300px",
//                                     width: "100%",
//                                 }}
//                                 value={selectedBrand}
//                                 onChange={(e) => onBrandChange(e.target.value)}
//                             >
//                                 {brands.map((brand) => (
//                                     <option key={brand.id} value={brand.id}>
//                                         {brand.brandname}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </div>
//                     )}

//                     {/* Product Type Filter */}
//                     {productTypes.length > 0 && (
//                         <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
//                             <span>Product Type:</span>
//                             <Form.Select
//                                 value={selectedProductType}
//                                 onChange={(e) => onProductTypeChange(e.target.value)}
//                             >
//                                 {productTypes.map((type) => (
//                                     <option key={type.value} value={type.value}>
//                                         {type.label}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </div>
//                     )}

//                     {/* Search Input */}
//                     <div style={{ marginLeft: "auto" }}>
//                         <FormControl
//                             type="text"
//                             placeholder="Search..."
//                             value={searchInput}
//                             onChange={(e) => setSearchInput(e.target.value)}
//                         />
//                     </div>
//                 </div>


//                 <Table striped bordered hover responsive className="brand-table">
//                     <thead>
//                         <tr>
//                             {header.map((head) => (
//                                 head.label !== "Action" ? (  
//                                     <th
//                                         key={head.field}
//                                         className={`brand-header-cell ${currentValue === head.field ? 'brand-sortable-active' : 'brand-sortable'}`}
//                                         onClick={() => sortHandler(head.field)}
//                                     >
//                                         {head.label}
//                                         {currentValue === head.field && (
//                                             <span className="brand-sort-icon">
//                                                 {sort === 'asc' ? '↑' : '↓'}
//                                             </span>
//                                         )}
//                                     </th>
//                                 ) : (
//                                     <th key={head.field} className="brand-header-cell">{head.label}</th>
//                                 )
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {projectionData?.length > 0 ? (
//                             projectionData.map((data) => (
//                                 <tr key={data.id} className="brand-row">
//                                     {header.map((head) => (
//                                         <td key={head.field} className="brand-cell">
//                                             {head.label === "Action" ? (
//                                                 <div className="brand-actions">
//                                                     <button
//                                                         className="brand-action-btn brand-view-btn"
//                                                         onClick={() => viewHandler("Id", data.id)}
//                                                         title="View"
//                                                     >
//                                                         <FiEye size={16} />
//                                                     </button>
//                                                     <button
//                                                         className="brand-action-btn brand-edit-btn"
//                                                         onClick={() => updateHandler(data.id)}
//                                                         title="Edit"
//                                                     >
//                                                         <FiEdit2 size={16} />
//                                                     </button>
//                                                     <button
//                                                         className="brand-action-btn brand-delete-btn"
//                                                         onClick={() => deleteHandler(data.id)}
//                                                         title="Delete"
//                                                     >
//                                                         <FiTrash2 size={16} />
//                                                     </button>
//                                                 </div>
//                                             ) : (
//                                                 <span
//                                                     className={`brand-cell-content ${head.label === "Id" ? 'brand-id-cell' : ''}`}
//                                                     onClick={() => viewHandler(head.label, data.id)}
//                                                 >
//                                                     {data[head.field]}
//                                                 </span>
//                                             )}
//                                         </td>
//                                     ))}
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr className="brand-row">
//                                 <td colSpan={header.length} className="brand-empty">
//                                     No data found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </Table>

//                 <div className="brand-pagination">
//                     <span className="brand-pagination-info">
//                         Showing {projectionData?.length || 0} of {totalEnteries} entries
//                     </span>

//                     <div className="brand-pagination-controls">
//                         <button
//                             className={`brand-pagination-btn ${currentPage === 0 ? 'disabled' : ''}`}
//                             onClick={previousHandler}
//                             disabled={currentPage === 0}
//                             title="Previous"
//                         >
//                             <IoIosArrowBack />
//                         </button>

//                         <div className="brand-pagination-pages">
//                             {renderPagination()}
//                         </div>

//                         <button
//                             className={`brand-pagination-btn ${currentPage >= pages - 1 ? 'disabled' : ''}`}
//                             onClick={nextHandler}
//                             disabled={currentPage >= pages - 1}
//                             title="Next"
//                         >
//                             <IoIosArrowForward />
//                         </button>
//                     </div>
//                 </div>
//             </Card.Body>
//         </Card>
//     );
// };

// export default ProductComponents;






// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import { FiEdit2, FiTrash2, FiEye } from "react-icons/fi";
// import { authHeader } from "../../services/auth-header";
// import { BASE_URL } from "../../services/Api";
// import { debounce } from "lodash";
// import { useFetchProductTableData } from "./useFetchProductTableData";
// import Swal from "sweetalert2";
// import "../Brand/BrandComponents.css";

// const ProductComponents = ({
//     header,
//     tableTitle,
//     apiField,
//     addButton,
//     createRoute,
//     updateRoute,
//     viewRoute,
//     selectedBrand = "1",
//     selectedProductType = "Finished",
//     brands = [],
//     productTypes = [],
//     onBrandChange,
//     onProductTypeChange
// }) => {
//     const { pointindex } = useParams();
//     const navigate = useNavigate();

//     const count = [{ value: 5 }, { value: 10 }, { value: 20 }, { value: 50 }];

//     const [searchInput, setSearchInput] = useState("");
//     const [search, setSearch] = useState(encodeURIComponent(" "));
//     const [currentPage, setCurrentPage] = useState(pointindex ? pointindex - 1 : 0);
//     const [limit, setLimit] = useState(5);
//     const [sort, setSort] = useState("desc");
//     const [currentValue, setCurrentValue] = useState("id");

//     const { data: projectionData, pages, totalEnteries, refetch } = useFetchProductTableData({
//         apiField,
//         limit,
//         sort,
//         currentValue,
//         search,
//         currentPage,
//         brandId: selectedBrand,
//         productType: selectedProductType
//     });

//     useEffect(() => {
//         const debounced = debounce(() => {
//             setSearch(encodeURIComponent(searchInput.trim() || " "));
//             setCurrentPage(0);
//         }, 300);
//         debounced();
//         return () => debounced.cancel();
//     }, [searchInput]);

//     useEffect(() => {
//         setCurrentPage(0);
//     }, [selectedBrand, selectedProductType]);

//     const limitHandler = (e) => {
//         setLimit(e.target.value);
//         setCurrentPage(0);
//     };

//     const sortHandler = (value) => {
//         setSort(sort === "asc" ? "desc" : "asc");
//         setCurrentValue(value);
//     };

//     const addButtonHandler = () => navigate(createRoute);

//     const updateHandler = (id) => {
//         navigate(`${updateRoute}/${id}/${currentPage + 1}`);
//     };

//     const deleteHandler = (id) => {
//         Swal.fire({
//             title: 'Are you sure?',
//             text: "You won't be able to revert this!",
//             icon: 'warning',
//             showCancelButton: true,
//             confirmButtonColor: '#3085d6',
//             cancelButtonColor: '#d33',
//             confirmButtonText: 'Yes, delete it!'
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 fetch(`${BASE_URL}${apiField}/delete/${id}`, {
//                     method: "DELETE",
//                     headers: authHeader()
//                 })
//                     .then(async (response) => {
//                         const responseText = await response.text();
//                         let responseData;
//                         try {
//                             responseData = JSON.parse(responseText);
//                         } catch {
//                             responseData = responseText;
//                         }
//                         if (response.ok) {
//                             await Swal.fire({
//                                 title: 'Deleted!',
//                                 text: typeof responseData === 'string'
//                                     ? responseData
//                                     : (responseData.message || 'Item deleted successfully'),
//                                 icon: 'success'
//                             });
//                             refetch();
//                         } else {
//                             throw new Error(typeof responseData === 'string'
//                                 ? responseData
//                                 : (responseData.message || 'Failed to delete item'));
//                         }
//                     })
//                     .catch(error => {
//                         Swal.fire({ title: 'Error', text: error.message, icon: 'error' });
//                     });
//             }
//         });
//     };

//     const viewHandler = (label, id) => {
//         if (label === "Id" && viewRoute) {
//             navigate(`${viewRoute}/${id}/${currentPage + 1}`);
//         }
//     };

//     const handleRecentPage = (i) => setCurrentPage(i - 1);

//     const previousHandler = () => {
//         setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
//     };

//     const nextHandler = () => {
//         setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
//     };

//     const renderPagination = () => {
//         const siblingsCount = 2;
//         const firstPage = 1;
//         const lastPage = pages;
//         let pageNumbers = [];

//         const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
//         const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

//         if (startPage > firstPage + 1) {
//             pageNumbers.push(
//                 <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
//                     {firstPage}
//                 </button>
//             );
//             pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     className={`bc-page-btn${i === currentPage + 1 ? ' bc-page-btn--active' : ''}`}
//                     onClick={() => handleRecentPage(i)}
//                 >
//                     {i}
//                 </button>
//             );
//         }

//         if (endPage < lastPage - 1) {
//             pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
//             pageNumbers.push(
//                 <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
//                     {lastPage}
//                 </button>
//             );
//         }

//         return pageNumbers;
//     };

//     return (
//         <div className="bc-card">

//             {/* ── HEADER ── */}
//             <div className="bc-card__header">
//                 <h6 className="bc-card__title">{tableTitle}</h6>
//                 {addButton && (
//                     <button className="bc-add-btn" onClick={addButtonHandler}>
//                         {addButton}
//                     </button>
//                 )}
//             </div>

//             {/* ── BODY ── */}
//             <div className="bc-card__body">

//                 {/* Controls row */}
//                 <div className="bc-controls bc-controls--wrap">

//                     {/* Show entries */}
//                     <div className="bc-entries">
//                         <span className="bc-entries__label">Show entries:</span>
//                         <select className="bc-entries__select" onChange={limitHandler} value={limit}>
//                             {count.map((item) => (
//                                 <option key={item.value} value={item.value}>{item.value}</option>
//                             ))}
//                         </select>
//                     </div>

//                     {/* Brand filter */}
//                     {brands.length > 0 && (
//                         <div className="bc-filter">
//                             <span className="bc-filter__label">Brand:</span>
//                             <select
//                                 className="bc-filter__select"
//                                 value={selectedBrand}
//                                 onChange={(e) => onBrandChange(e.target.value)}
//                             >
//                                 {brands.map((brand) => (
//                                     <option key={brand.id} value={brand.id}>
//                                         {brand.brandname}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     )}

//                     {/* Product type filter */}
//                     {productTypes.length > 0 && (
//                         <div className="bc-filter">
//                             <span className="bc-filter__label">Product Type:</span>
//                             <select
//                                 className="bc-filter__select"
//                                 value={selectedProductType}
//                                 onChange={(e) => onProductTypeChange(e.target.value)}
//                             >
//                                 {productTypes.map((type) => (
//                                     <option key={type.value} value={type.value}>
//                                         {type.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                     )}

//                     {/* Search */}
//                     <input
//                         className="bc-search bc-search--right"
//                         type="text"
//                         placeholder="Search..."
//                         value={searchInput}
//                         onChange={(e) => setSearchInput(e.target.value)}
//                     />
//                 </div>

//                 {/* Table */}
//                 <div className="bc-table-wrapper">
//                     <table className="bc-table">
//                         <thead>
//                             <tr>
//                                 {header.map((head) => (
//                                     head.label !== "Action" ? (
//                                         <th
//                                             key={head.field}
//                                             className={`bc-th bc-th--sortable${currentValue === head.field ? ' bc-th--active' : ''}`}
//                                             onClick={() => sortHandler(head.field)}
//                                         >
//                                             {head.label}
//                                             {currentValue === head.field && (
//                                                 <span className="bc-sort-icon">
//                                                     {sort === 'asc' ? ' ↑' : ' ↓'}
//                                                 </span>
//                                             )}
//                                         </th>
//                                     ) : (
//                                         <th key={head.field} className="bc-th">{head.label}</th>
//                                     )
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {projectionData?.length > 0 ? (
//                                 projectionData.map((data) => (
//                                     <tr key={data.id} className="bc-tr">
//                                         {header.map((head) => (
//                                             <td key={head.field} className="bc-td">
//                                                 {head.label === "Action" ? (
//                                                     <div className="bc-actions">
//                                                         <button
//                                                             className="bc-action-btn bc-action-btn--view"
//                                                             onClick={() => viewHandler("Id", data.id)}
//                                                             title="View"
//                                                         >
//                                                             <FiEye size={15} />
//                                                         </button>
//                                                         <button
//                                                             className="bc-action-btn bc-action-btn--edit"
//                                                             onClick={() => updateHandler(data.id)}
//                                                             title="Edit"
//                                                         >
//                                                             <FiEdit2 size={15} />
//                                                         </button>
//                                                         <button
//                                                             className="bc-action-btn bc-action-btn--delete"
//                                                             onClick={() => deleteHandler(data.id)}
//                                                             title="Delete"
//                                                         >
//                                                             <FiTrash2 size={15} />
//                                                         </button>
//                                                     </div>
//                                                 ) : (
//                                                     <span
//                                                         className={`bc-cell-text${head.label === "Id" ? ' bc-cell-text--id' : ''}`}
//                                                         onClick={() => viewHandler(head.label, data.id)}
//                                                     >
//                                                         {data[head.field]}
//                                                     </span>
//                                                 )}
//                                             </td>
//                                         ))}
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr className="bc-tr">
//                                     <td colSpan={header.length} className="bc-td bc-td--empty">
//                                         No data found
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Pagination */}
//                 <div className="bc-pagination">
//                     <span className="bc-pagination__info">
//                         Showing {projectionData?.length || 0} of {totalEnteries} entries
//                     </span>

//                     <div className="bc-pagination__controls">
//                         <button
//                             className={`bc-nav-btn${currentPage === 0 ? ' bc-nav-btn--disabled' : ''}`}
//                             onClick={previousHandler}
//                             disabled={currentPage === 0}
//                             title="Previous"
//                         >
//                             <IoIosArrowBack />
//                         </button>

//                         <div className="bc-pages">
//                             {renderPagination()}
//                         </div>

//                         <button
//                             className={`bc-nav-btn${currentPage >= pages - 1 ? ' bc-nav-btn--disabled' : ''}`}
//                             onClick={nextHandler}
//                             disabled={currentPage >= pages - 1}
//                             title="Next"
//                         >
//                             <IoIosArrowForward />
//                         </button>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default ProductComponents;





import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FiEdit2, FiTrash2, FiEye, FiRefreshCw } from "react-icons/fi";
import { authHeader } from "../../services/auth-header";
import { BASE_URL } from "../../services/Api";
import { debounce } from "lodash";
import { useFetchProductTableData } from "./useFetchProductTableData";
import Swal from "sweetalert2";
import "../Brand/BrandComponents.css";

const ProductComponents = ({
    header,
    tableTitle,
    apiField,
    addButton,
    createRoute,
    updateRoute,
    viewRoute,
    selectedBrand = "1",
    selectedProductType = "Finished",
    brands = [],
    productTypes = [],
    onBrandChange,
    onProductTypeChange
}) => {
    const { pointindex } = useParams();
    const navigate = useNavigate();

    const count = [{ value: 5 }, { value: 10 }, { value: 20 }, { value: 50 }];

    const [searchInput, setSearchInput] = useState("");
    const [search, setSearch] = useState(encodeURIComponent(" "));
    const [currentPage, setCurrentPage] = useState(pointindex ? pointindex - 1 : 0);
    const [limit, setLimit] = useState(5);
    const [sort, setSort] = useState("desc");
    const [currentValue, setCurrentValue] = useState("id");
    const [isRefreshing, setIsRefreshing] = useState(false);

    const { data: projectionData, pages, totalEnteries, refetch } = useFetchProductTableData({
        apiField,
        limit,
        sort,
        currentValue,
        search,
        currentPage,
        brandId: selectedBrand,
        productType: selectedProductType
    });

    useEffect(() => {
        const debounced = debounce(() => {
            setSearch(encodeURIComponent(searchInput.trim() || " "));
            setCurrentPage(0);
        }, 300);
        debounced();
        return () => debounced.cancel();
    }, [searchInput]);

    useEffect(() => {
        setCurrentPage(0);
    }, [selectedBrand, selectedProductType]);

    const limitHandler = (e) => {
        setLimit(e.target.value);
        setCurrentPage(0);
    };

    const sortHandler = (value) => {
        setSort(sort === "asc" ? "desc" : "asc");
        setCurrentValue(value);
    };

    const addButtonHandler = () => navigate(createRoute);

    const refreshHandler = () => {
        setIsRefreshing(true);
        refetch();
        setTimeout(() => setIsRefreshing(false), 600);
    };

    const updateHandler = (id) => {
        navigate(`${updateRoute}/${id}/${currentPage + 1}`);
    };

    const deleteHandler = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${BASE_URL}${apiField}/delete/${id}`, {
                    method: "DELETE",
                    headers: authHeader()
                })
                    .then(async (response) => {
                        const responseText = await response.text();
                        let responseData;
                        try {
                            responseData = JSON.parse(responseText);
                        } catch {
                            responseData = responseText;
                        }
                        if (response.ok) {
                            await Swal.fire({
                                title: 'Deleted!',
                                text: typeof responseData === 'string'
                                    ? responseData
                                    : (responseData.message || 'Item deleted successfully'),
                                icon: 'success'
                            });
                            refetch();
                        } else {
                            throw new Error(typeof responseData === 'string'
                                ? responseData
                                : (responseData.message || 'Failed to delete item'));
                        }
                    })
                    .catch(error => {
                        Swal.fire({ title: 'Error', text: error.message, icon: 'error' });
                    });
            }
        });
    };

    const viewHandler = (label, id) => {
        if (label === "Id" && viewRoute) {
            navigate(`${viewRoute}/${id}/${currentPage + 1}`);
        }
    };

    const handleRecentPage = (i) => setCurrentPage(i - 1);

    const previousHandler = () => {
        setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
    };

    const nextHandler = () => {
        setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
    };

    const renderPagination = () => {
        const siblingsCount = 2;
        const firstPage = 1;
        const lastPage = pages;
        let pageNumbers = [];

        const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
        const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

        if (startPage > firstPage + 1) {
            pageNumbers.push(
                <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
                    {firstPage}
                </button>
            );
            pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`bc-page-btn${i === currentPage + 1 ? ' bc-page-btn--active' : ''}`}
                    onClick={() => handleRecentPage(i)}
                >
                    {i}
                </button>
            );
        }

        if (endPage < lastPage - 1) {
            pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
            pageNumbers.push(
                <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
                    {lastPage}
                </button>
            );
        }

        return pageNumbers;
    };

    return (
        <div className="bc-card">

            {/* ── TOOLBAR ── */}
            <div className="bc-toolbar">
                {/* Left: Search (flex-grow) */}
                <input
                    className="bc-search"
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                />

                {/* Right: Filters + Show entries + Refresh + Add */}
                <div className="bc-toolbar__right">
                    {/* Brand filter */}
                    {brands.length > 0 && (
                        <>
                            <span className="bc-filter__label">Brand:</span>
                            <select
                                className="bc-filter__select"
                                value={selectedBrand}
                                onChange={(e) => onBrandChange(e.target.value)}
                            >
                                {brands.map((brand) => (
                                    <option key={brand.id} value={brand.id}>
                                        {brand.brandname}
                                    </option>
                                ))}
                            </select>
                        </>
                    )}

                    {/* Product type filter */}
                    {productTypes.length > 0 && (
                        <>
                            <span className="bc-filter__label">Type:</span>
                            <select
                                className="bc-filter__select"
                                value={selectedProductType}
                                onChange={(e) => onProductTypeChange(e.target.value)}
                            >
                                {productTypes.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </>
                    )}

                    <span className="bc-entries__label">Show:</span>
                    <select className="bc-entries__select" onChange={limitHandler} value={limit}>
                        {count.map((item) => (
                            <option key={item.value} value={item.value}>{item.value}</option>
                        ))}
                    </select>

                    <button
                        className={`bc-refresh-btn${isRefreshing ? ' bc-refresh-btn--spinning' : ''}`}
                        onClick={refreshHandler}
                        title="Refresh"
                    >
                        <FiRefreshCw size={14} />
                    </button>

                    {addButton && (
                        <button className="bc-add-btn" onClick={addButtonHandler}>
                            {addButton}
                        </button>
                    )}
                </div>
            </div>

            {/* ── TABLE ── */}
            <div className="bc-table-wrapper">
                <table className="bc-table">
                    <thead>
                        <tr>
                            {header.map((head) => (
                                head.label !== "Action" ? (
                                    <th
                                        key={head.field}
                                        className={`bc-th bc-th--sortable${currentValue === head.field ? ' bc-th--active' : ''}`}
                                        onClick={() => sortHandler(head.field)}
                                    >
                                        {head.label}
                                        {currentValue === head.field && (
                                            <span className="bc-sort-icon">
                                                {sort === 'asc' ? ' ↑' : ' ↓'}
                                            </span>
                                        )}
                                    </th>
                                ) : (
                                    <th key={head.field} className="bc-th">{head.label}</th>
                                )
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {projectionData?.length > 0 ? (
                            projectionData.map((data) => (
                                <tr key={data.id} className="bc-tr">
                                    {header.map((head) => (
                                        <td key={head.field} className="bc-td">
                                            {head.label === "Action" ? (
                                                <div className="bc-actions">
                                                    <button
                                                        className="bc-action-btn bc-action-btn--view"
                                                        onClick={() => viewHandler("Id", data.id)}
                                                        title="View"
                                                    >
                                                        <FiEye size={15} />
                                                    </button>
                                                    <button
                                                        className="bc-action-btn bc-action-btn--edit"
                                                        onClick={() => updateHandler(data.id)}
                                                        title="Edit"
                                                    >
                                                        <FiEdit2 size={15} />
                                                    </button>
                                                    <button
                                                        className="bc-action-btn bc-action-btn--delete"
                                                        onClick={() => deleteHandler(data.id)}
                                                        title="Delete"
                                                    >
                                                        <FiTrash2 size={15} />
                                                    </button>
                                                </div>
                                            ) : (
                                                <span
                                                    className={`bc-cell-text${head.label === "Id" ? ' bc-cell-text--id' : ''}`}
                                                    onClick={() => viewHandler(head.label, data.id)}
                                                >
                                                    {data[head.field]}
                                                </span>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr className="bc-tr">
                                <td colSpan={header.length} className="bc-td bc-td--empty">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* ── PAGINATION ── */}
            <div className="bc-pagination">
                <span className="bc-pagination__info">
                    Showing {projectionData?.length || 0} of {totalEnteries} entries
                </span>

                <div className="bc-pagination__controls">
                    <button
                        className={`bc-nav-btn${currentPage === 0 ? ' bc-nav-btn--disabled' : ''}`}
                        onClick={previousHandler}
                        disabled={currentPage === 0}
                        title="Previous"
                    >
                        <IoIosArrowBack />
                    </button>

                    <div className="bc-pages">
                        {renderPagination()}
                    </div>

                    <button
                        className={`bc-nav-btn${currentPage >= pages - 1 ? ' bc-nav-btn--disabled' : ''}`}
                        onClick={nextHandler}
                        disabled={currentPage >= pages - 1}
                        title="Next"
                    >
                        <IoIosArrowForward />
                    </button>
                </div>
            </div>

        </div>
    );
};

export default ProductComponents;